import { lazy } from 'react';

export { default as AccountActivity } from '@/pages/AccountActivity';
export { default as CreateApiPage } from '@/pages/apiManagement/createApiPage';
export { default as Notifications } from '@/pages/Notifications';
// export { default as Por } from '@/pages/ProofOfReserve';
export { default as Retrieve } from '@/pages/Retrieve';
export { default as SubAccountLogin } from '@/pages/subAccountLogin';
export { default as Unsubscribe } from '@/pages/Unsubscribe/Unsubscribe';
export { default as UserFeedback } from '@/pages/UserFeedback/UserFeedback';
export const OfflineVerify = lazy(() => import('@/pages/offline-verify'));

export const AutoBanAccount = lazy(() => import('@/pages/autoBanAccount'));

export const EditApiPage = lazy(
  () => import('@/pages/apiManagement/editApiPage'),
);

export const TrustedDevice = lazy(() => import('@/pages/trustedDevice'));
export const TradingTool = lazy(() => import('@/pages/tradingTool'));
export const WithdrawCoinsSetting = lazy(
  () => import('@/pages/WithdrawCoinsSetting'),
);

export const BindRequest = lazy(
  () => import('@/pages/subAccount/comps/BindRequest/BindRequest'),
);

// export const Por = lazy(() => import('@/pages/ProofOfReserve'));
// export const ReserveRatio = lazy(() => import('@/pages/ReserveRatio'));
// export const IndependentAuditReport = lazy(
//   () => import('@/pages/IndependentAuditReport'),
// );

// export const AuditVerify = lazy(() => import('@/pages/AuditVerify'));
// export const MerkleTree = lazy(() => import('@/pages/merkleTree'));
export const OauthAdmin = lazy(() => import('@/pages/oauthAdmin'));

export const ApiBrokerDashboard = lazy(
  () => import('@/outer/apiBrokerDashboard'),
);

export const ModifyPasswordPage = lazy(
  () => import('@/pages/security/comps/modifyPassword/ModifyPasswordPage'),
);
export const NotificationsSetting = lazy(
  () => import('@/pages/Notifications-setting'),
);

export const PasskeysManagement = lazy(
  () => import('@/pages/security/comps/passkey/PasskeyManagement'),
);

export { default as ApiManagement } from '@/pages/apiManagement';
// export const ApiManagement = lazy(() => import('@/pages/apiManagement'));
export { default as Security } from '@/pages/security';
export { default as SubAccount } from '@/pages/subAccount/SubAccount';
// export const SubAccount = lazy(() => import('@/pages/subAccount/SubAccount'));
// export const Security = lazy(() => import('@/pages/security'));
export const TradingViewAlert = lazy(() => import('@/pages/TradingViewAlert'));
export const Settings = lazy(() => import('@/pages/settings'));
export const Audit = lazy(() => import('@/pages/Audit'));

export { default as AccountInfo } from '@/pages/AccountInfo';
export const Statement = lazy(() => import('@/pages/statement'));
export const PrimaryDevice = lazy(() => import('@/pages/PrimaryDevice'));
export { default as DeleteAccount } from '@/pages/DeleteAccount';
